<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <!--<el-badge :value="200" :max="99" class="item hover-effect">-->
        <!--<el-button type="text" size="small" @click="openDrawer">消息中心</el-button>-->
        <!--</el-badge>-->
      </template>
      <Drawer class="right-menu-item" style="vertical-align: baseline" :news-data="newsData" :isReadNum="isReadNum"/>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper" style="display: flex">
          <img :src="url+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <i class="el-icon-caret-bottom" />
          <div style="margin-left:5px">
            <div :class="isAdmin?'textstyle':''" :style="{'lineHeight':(!roleName?'40px':'')}">{{ userName }}</div>
            <div v-if="!isAdmin">{{roleName}}</div>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/infoMation/index" v-if="!isAdmin">
            <el-dropdown-item class="items" style="line-height: 36px;padding: 0 20px;">个人信息</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided class="items" style="line-height: 36px;padding: 0 20px;" @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div>
      <el-drawer
        title="我是标题"
        :modal="false"
        :visible.sync="drawer"
        :before-close="handleClose"
      >
        <span>我来啦!</span>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { noticeList, read } from '@/api/newsCenter'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Drawer from '@/components/Drawer'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Drawer
  },
  data() {
    return {
      url: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      drawer: false,
      newsData: [],
      isReadNum: 0
    }
  },
  created() {
    this.noticeList()
    this.resdClick()
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'isAdmin',
      'roleName'
    ]),
    userName() {
      return this.$store.getters.name
    }
  },
  methods: {
    noticeList() {
      noticeList({ id: this.key }).then(res => {
        if (res && res.code === 0) {
          if (res.data && res.data.length > 0) {
            this.newsData = res.data
          } else {
            this.newsData = []
          }
        } else {
          this.$message(res.msg)
        }
      }).catch(res => {
        console.log(res.msg)
      })
    },
    resdClick() {
      read().then(res => {
        if (res && res.code === 0) {
          this.isReadNum = res.data
        } else {
          this.$message(res.msg)
        }
      }).catch(res => {
        console.log(res.msg)
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      sessionStorage.clear()
      localStorage.clear()
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    openDrawer() {
      this.drawer = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #F0F5FF;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 20px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 12px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  .textstyle {
    line-height: 40px;
  }
}
</style>
